<template>
  <div class="pills-container">
    <draggable class="draggable" item-key="id" v-bind="dragOptions" v-model="rearrangableColumns" @end="onRearrangeEnd">
      <template v-for="(column, index) in rearrangableColumns">
        <div class="pill">
          {{ column.displayName }}
          <font-awesome-icon class="pill-close" :icon="['fas', 'times']" @click="onRemove(index)" />
        </div>
      </template>
    </draggable>
    <fts-tippy triggerClass="sidenav-menu-outer" content="Add information" :options="{ placement: 'bottom' }"
      class="sidenav-menu">
      <fts-form-design-shortcut ref="ftsAddColumnPopUp" :options="availableInformation" :selectedOptions="rearrangableColumns" @option:selected="addViewInformation"
        @option:create="createViewInformation" :disableCreate="true">
        <font-awesome-icon class="pill-add" :icon="['fas', 'plus']" fixed-width />
      </fts-form-design-shortcut>
    </fts-tippy>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import FTSBtn from '../elements/FTSBtn';
import FTSListDesignerLayouter from './FTSListDesignerLayouter';
import FTSListingColumnDesignModal from './FTSListingColumnDesignModal';
import FTSTippy from '../elements/FTSTippy';
import FTSFormDesignShortcut from './FTSFormDesignShortcut';
import { store as canvasDesignStore } from "../store/canvasDesignStore";
import canvasDesign from '../commons/canvasDesign';
import { clientStore } from '../store/clientStore';

export default {
  data: () => ({
    rearrangableColumns: [],
  }),
  props: {
    informations: [],
    list: {
      type: Object,
      default: () => ({})
    },
    dragOptions: {
      animation: 200,
      ghostClass: 'ghost'
    },
    createInformation: {
      type: Function,
      required: false
    }
  },
  model: {
    prop: "list",
  },
  components: {
    draggable,
    "fts-btn": FTSBtn,
    "fts-list-designer-layouter": FTSListDesignerLayouter,
    "fts-listing-column-design-modal": FTSListingColumnDesignModal,
    "fts-tippy": FTSTippy,
    'fts-form-design-shortcut': FTSFormDesignShortcut,
  },
  methods: {
    onRearrangeEnd() {
      this.rearrangableColumns = [...this.rearrangableColumns];
    },
    onRemove(index) {
      this.rearrangableColumns.splice(index, 1);
    },
    addViewInformation(item){
      this.rearrangableColumns.push(item);
    },
    async createViewInformation(item) {
      /* create the information in canvas */
      const res = await this.createInformation(item);

      console.debug('info from creation');
      console.debug(res);

      /* locally in this components */
      this.rearrangableColumns.push(res);
    },
  },
  mounted() {
  },
  created() {
    this.rearrangableColumns = [...this.list.columns];
  },
  computed: {
    availableInformation() {
      const usedKeys = new Set(
        this.rearrangableColumns.map(col => col.id)
      )

      return this.informations.filter(
        info => !usedKeys.has(info.id)
      )
    }
  },
  watch: {
    rearrangableColumns: {
      deep: true,
      handler(val) {
        console.debug('inner component updated');
        this.list.columns = [...val];
        console.debug(this.list.columns);
      }
    }
  },

};
</script>

<style lang="scss" scoped>
.pills-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  /* 间距 */


  .draggable {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .pill {
    border: var(--fts-primary) 2px solid;
    padding: 4px 10px;
    font-size: 16px;
    border-radius: 99px;
    color: var(--fts-text);

    &:hover {
      background: var(--inistate-color-primary-50)
    }

    >.pill-close {
      margin-left: 2px;
      color: var(--fts-gray-200);

      &:hover {
        color: var(--fts-default);
      }
    }
  }

  .pill-add {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--fts-default);
    border-radius: 99px;
    font-size: px;
    padding: 4px;

    cursor: pointer;

    &:hover {
      background-color: var(--fts-gray-300);
      background-color: var(--fts-gray-50);
    }
  }

}
</style>
